import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { initSessionToken } from "@/lib/sessionToken";

// Capture Emergent Google Auth session_id from the URL fragment BEFORE React/router mounts.
try {
  const m = window.location.hash && window.location.hash.match(/session_id=([^&]+)/);
  if (m) {
    window.__HITMAX_GSID = decodeURIComponent(m[1]);
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }
} catch (e) {}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// C10 : le jeton de session natif est relu depuis le Keychain / Keystore AVANT le premier rendu.
initSessionToken().finally(() => {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
